import { useState, useEffect } from 'react';

export const usePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // 1. Detectar si ya está instalada la aplicación (modo standalone)
    const checkStandalone = () => {
      const isStandaloneMode = 
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.includes('android-app://');
      
      setIsStandalone(isStandaloneMode);
      return isStandaloneMode;
    };

    // 2. Detectar si es un dispositivo iOS (iPhone / iPad / iPod)
    const checkIOS = (standaloneMode) => {
      const userAgent = window.navigator.userAgent || '';
      const platform = window.navigator.platform || '';
      
      const isAppleDevice = 
        /iphone|ipad|ipod/i.test(userAgent) || 
        (platform.toLowerCase().includes('mac') && window.navigator.maxTouchPoints > 1);
      
      // Es iOS y NO está ejecutándose en modo standalone instalado
      setIsIOS(isAppleDevice && !standaloneMode);
    };

    const standalone = checkStandalone();
    checkIOS(standalone);

    // 3. Capturar el prompt nativo en Android/PC (Chrome/Edge/Brave)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const triggerInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setIsInstallable(false);
      setDeferredPrompt(null);
    }
  };

  return {
    isInstallable,
    isStandalone,
    isIOS,
    triggerInstall
  };
};

export default usePWAInstall;

